import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { tableRowClasses, Box, Table as Table$1, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import keygen from 'uuid/v4';
import { Toolbar } from '../Toolbar/Toolbar.js';
import { Typography } from '../Typography/Typography.js';
var _excluded = ["columnsToRender", "rows", "CellComponent", "HeaderComponent", "hover", "align", "maxHeight", "padding", "title", "toolbarItems", "isCustomRow"];
var styles = {
  tableRoot: {
    overflowY: 'auto'
  },
  body: _defineProperty({
    overflow: 'auto'
  }, "& .".concat(tableRowClasses['root'], ":hover"), {
    backgroundColor: archerConstants.archerHover
  }),
  titleArea: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      display: 'block',
      width: 'auto'
    },
    '& div:last-child': {
      marginLeft: 'auto',
      '& > span': {
        marginY: 1,
        marginLeft: 1,
        marginRight: -1
      }
    }
  }
};

var createToolbar = function createToolbar(items) {
  var toolbar = [{
    id: 1,
    position: 'right',
    items: items
  }];
  return /*#__PURE__*/React.createElement(Toolbar, {
    items: toolbar
  });
};

var Table = function Table(_ref) {
  var columnsToRender = _ref.columnsToRender,
      rows = _ref.rows,
      CellComponent = _ref.CellComponent,
      HeaderComponent = _ref.HeaderComponent,
      hover = _ref.hover,
      align = _ref.align,
      maxHeight = _ref.maxHeight,
      padding = _ref.padding,
      title = _ref.title,
      toolbarItems = _ref.toolbarItems,
      _ref$isCustomRow = _ref.isCustomRow,
      isCustomRow = _ref$isCustomRow === void 0 ? false : _ref$isCustomRow,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var tableRoot = styles.tableRoot,
      body = styles.body,
      titleArea = styles.titleArea;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    sx: titleArea
  }, title && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, title), toolbarItems && toolbarItems.length > 0 && createToolbar(toolbarItems)), /*#__PURE__*/React.createElement(Box, {
    sx: tableRoot,
    style: {
      maxHeight: "".concat(maxHeight, "px")
    }
  }, /*#__PURE__*/React.createElement(Table$1, _extends({
    padding: padding
  }, restProps), /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, columnsToRender.map(function (column) {
    return /*#__PURE__*/React.createElement(TableCell, {
      key: column.Title,
      align: align
    }, HeaderComponent ? /*#__PURE__*/React.createElement(HeaderComponent, null, column.Title) : /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, column.Title));
  }))), /*#__PURE__*/React.createElement(TableBody, {
    sx: body
  }, Object.values(rows).map(function (row) {
    return isCustomRow ? row : /*#__PURE__*/React.createElement(TableRow, {
      key: keygen(),
      hover: hover
    }, columnsToRender.map(function (column) {
      var value = row[column.Property];
      var textValue = typeof value === 'string' ? /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, value) : value;
      return /*#__PURE__*/React.createElement(TableCell, {
        key: column.Property,
        align: align
      }, CellComponent ? /*#__PURE__*/React.createElement(CellComponent, null, value) : textValue);
    }));
  })))));
};

Table.displayName = 'Table';
export { Table };